import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { User } from '../../../../../../libs/a2z-lib/src/lib/models/user.model';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import {
  ConsultService,
  SnackService,
  DeleteDialogComponent,
  // SocketService,
  TeleconsultResponse,
  Consult,
  ProviderService,
  AuthService,
} from '@school/a2z-lib';

@Component({
  selector: 'maven-forms-dashboard',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormsComponent {
  user = new BehaviorSubject<User>(null);
    showToolbar = true;
providerMode = false;


userName: string = '';




  

  currentStep = 1;
  practiceForm: FormGroup;
  ehrForm: FormGroup;
  clearinghouseForm: FormGroup;
  payorForm: FormGroup;
   providerForm: FormGroup;
  form: any;
  isSubmitting = false;

  is2FAEnabled = false;

toggle2FA(event: MatSlideToggleChange) {
  this.is2FAEnabled = event.checked;
  const clientDataString = localStorage.getItem('temp_numberclient');
  const payload = {
    authetication:this.is2FAEnabled,
    user_id: clientDataString
  }
  console.log('2FA Enabled:', this.is2FAEnabled);
  this._AuthService.sendFactorAuthentication(payload).subscribe({
    next: (res) => {
      console.log('Removed file sent:', res);
      const user = JSON.parse(localStorage.getItem('userDataclient') || '{}');
      console.log("User dictionary before:",user)
      user.is2fa = JSON.stringify(this.is2FAEnabled); // store as string to match original logic
      console.log("User 2FA:",user.is2fa)
      localStorage.setItem('userDataclient', JSON.stringify(user));
      console.log("User dictionary after:",user)


      
    },
    error: (err) => console.error('Error sending removed file:', err)
  });
}

  // http: any;
  // formContainer: any;
  @ViewChild('formContainer', { static: false }) formContainer!: ElementRef;

  constructor(private router: Router,
private fb: FormBuilder,private http: HttpClient,private _AuthService: AuthService,private _snackBar: MatSnackBar,) {
      this.checkPathAndToggleToolbar();
    this.initProviderForm();

    
  this.initPracticeForm();
    this.initEhrForm();
    this.initClearinghouseForm();
    this.initPayorForm();
    


    
    
  }
 


   createForm(): void {
    this.clearinghouseForm = this.fb.group({
      clearinghouseName: ['', Validators.required],
      clearinghouseWebsite: ['', [Validators.required, Validators.pattern('https?://.+')]],
      credentials: this.fb.array([this.createCredentialGroup()])
    });
  }
   createCredentialGroup(): FormGroup {
    return this.fb.group({
      username: [''],
      password: [''],
      securityQA: [''],
      mobileOTP: [''],
      forgotEmail: ['', Validators.email],
      accessLevel: ['']
    });
  }

  get credentials(): FormArray {
    return this.clearinghouseForm.get('credentials') as FormArray;
  }
  addCredential(): void {
    this.credentials.push(this.createCredentialGroup());
  }


createClearinghouseName(): FormGroup {
  return this.fb.group({
    name: ['', Validators.required]
  });
}

get clearinghouseNames(): FormArray {
  return this.clearinghouseForm.get('clearinghouseNames') as FormArray;
}

addClearinghouseName(): void {
  this.clearinghouseNames.push(this.createClearinghouseName());
}

removeClearinghouseName(index: number): void {
  if (this.clearinghouseNames.length > 1) {
    this.clearinghouseNames.removeAt(index);
  }
}


  removeCredential(index: number): void {
    if (this.credentials.length > 1) {
      this.credentials.removeAt(index);
    }
  }
  removeLocation(index: number): void {
  this.locations.removeAt(index);
}

 initPracticeForm(): void {
  this.practiceForm = this.fb.group({
    practiceName: ['', Validators.required],
    locations: this.fb.array([this.createLocationGroup()])
  });
}

  initEhrForm(): void {
    this.ehrForm = this.fb.group({
      ehrName: ['', Validators.required],
      supportContacts: this.fb.array([this.createSupportContact()]),
      loginCredentials: this.fb.array([this.createLoginCredential()])
    });
  }
  initClearinghouseForm(): void {
  this.clearinghouseForm = this.fb.group({
    clearinghouseNames: this.fb.array([this.createClearinghouseName()]),
    credentials: this.fb.array([this.createClearinghouseCredential()])
  });
}
 initProviderForm(): void {
    this.providerForm = this.fb.group({
      providers: this.fb.array([this.createProvider()])
    });
  }



 addPracticeContact(index: number) {
  const practiceContacts = this.getPracticeContacts(index);
  practiceContacts.push(this.createPracticeContactFormGroup());
}
createPracticeContactFormGroup() {
  return this.fb.group({
    phone: ['', Validators.required],
    fax: [''],
    email: [''],
    website: ['']
  });
}

addEmployeeContact(locationIndex: number): void {
  this.getEmployeeContacts(locationIndex).push(this.createEmployeeContact());
}


//   checkPathAndToggleToolbar() {
//     const currentPath = window.location.pathname;

//     console.log(currentPath,'kkk')

//     this.showToolbar = !currentPath.endsWith('/provider');

//   this._AuthService.getFormList().subscribe(
//   (response) => {
//     const responseData = response.body.forms[0].json_data;
//     console.log("Form JSON:", responseData);
//     this.populateFormsFromJson(responseData);
//   },
//   (error) => {
//     console.error('Error loading form:', error);
//   }
// );




//   }

checkPathAndToggleToolbar(): void {
  const currentPath = window.location.pathname;
  console.log(currentPath, 'kkk');

  // Match `/v1/provider/:id` and extract `id`
  const providerMatch = currentPath.match(/^\/v1\/provider\/(\d+)$/);

  if (providerMatch) {
    const providerId = providerMatch[1];
    this.showToolbar = false;
     this.providerMode = true;

    console.log(this.providerMode,'dksfhsjk')
    // ✅ Load form data using the extracted ID
    this._AuthService.getFormList(providerId).subscribe(
      (response) => {
        const responseData = response.body.forms[0].json_data;
        console.log("Form JSON:", responseData);
        this.populateFormsFromJson(responseData);
      },
      (error) => {
        console.error('Error loading form:', error);
      }
    );
  } else {
    // Not on /v1/provider/:id → show toolbar, don't fetch
    this.showToolbar = true;
    this.providerMode = false;

  }
}

ngOnInit(): void {
  const clientDataString = localStorage.getItem('temp_numberclient');
  if (clientDataString) {
    // this._AuthService.getFormList(clientDataString).subscribe(
    //   (response) => {
    //     const responseData = response.body.forms[0].json_data;
    //     console.log("Form JSON:", responseData);

    //     this.practiceForm.patchValue(responseData.practice_info);
    //     this.setPracticeLocations(responseData.practice_info?.locations || []);

    //     this.ehrForm.patchValue({
    //       ehrName: responseData.ehr_system?.ehrName || ''
    //     });
    //     this.setSupportContacts(responseData.ehr_system?.supportContacts || []);
    //     this.setLoginCredentials(responseData.ehr_system?.loginCredentials || []);

    //     this.clearinghouseForm.patchValue({
    //       clearinghouseName: responseData.clearing_house?.clearinghouseName || '',
    //       clearinghouseWebsite: responseData.clearing_house?.clearinghouseWebsite || ''
    //     });
    //     this.setClearinghouseCredentials(responseData.clearing_house?.credentials || []);
    //     this.setClearinghouseNames(responseData.clearing_house?.clearinghouseNames || []);

    //     this.payorForm.patchValue({
    //       payorLogins: responseData.payor_and_providers?.payorLogins || [],
    //       otherPayorInfo: responseData.payor_and_providers?.otherPayorInfo || ''
    //     });
    //     this.setProviders(responseData.payor_and_providers?.providers || []);
    //   },
    //   (error) => {
    //     console.error('Error loading form:', error);
    //   }
    // );

  const user = JSON.parse(localStorage.getItem('userDataclient') || '{}');
  this.userName = user?.name + " "+ user?.last_name|| 'User';

  this.is2FAEnabled = user.is2fa ? JSON.parse(user.is2fa) : false;


this._AuthService.getFormList(clientDataString).subscribe(
  (response) => {
    console.log('Full Response:', response);

    const forms = response?.body?.forms;
    if (!forms || forms.length === 0) {
      console.warn('No forms found in response');
      return;
    }

    const responseData = forms[0].json_data;
    console.log("Form JSON:", responseData);
    this.populateFormsFromJson(responseData);
  },
  (error) => {
    console.error('Error fetching form list:', error);
  }
);
  
  }
}

  // const Clientdata =JSON.parse(localStorage.getItem('userDataclient'))


populateFormsFromJson(responseData: any): void {



  // Practice Info
  this.practiceForm.patchValue(responseData.practice_info || {});
  this.setPracticeLocations(responseData.practice_info?.locations || []);

  // EHR System
  this.ehrForm.patchValue({
    ehrName: responseData.ehr_system?.ehrName || ''
  });
  this.setSupportContacts(responseData.ehr_system?.supportContacts || []);
  this.setLoginCredentials(responseData.ehr_system?.loginCredentials || []);

  // Clearinghouse
  this.clearinghouseForm.patchValue({
    clearinghouseName: responseData.clearing_house?.clearinghouseName || '',
    clearinghouseWebsite: responseData.clearing_house?.clearinghouseWebsite || ''
  });
  this.setClearinghouseCredentials(responseData.clearing_house?.credentials || []);
  this.setClearinghouseNames(responseData.clearing_house?.clearinghouseNames || []);
  
    this.setProviders(responseData.payor_and_providers?.providers || []);
        this.setProviderFiles(responseData.payor_and_providers?.providers || []);
  // Payor and Providers
  this.payorForm.patchValue({
    payorLogins: responseData.payor_and_providers?.payorLogins || [],
    otherPayorInfo: responseData.payor_and_providers?.otherPayorInfo || ''
  });

  
  this.setProviders(responseData.payor_and_providers?.providers || []);


}

setSupportContacts(contacts: any[]) {
  const supportArray = this.fb.array([]);
  contacts.forEach(contact => {
    supportArray.push(this.fb.group({
      contactName: [contact.contactName],
      email: [contact.email],
      phone: [contact.phone],
      website: [contact.website]
    }));
  });
  this.ehrForm.setControl('supportContacts', supportArray);
}

setLoginCredentials(creds: any[]) {
  const credArray = this.fb.array([]);
  creds.forEach(cred => {
    credArray.push(this.fb.group({
      username: [cred.username],
      password: [cred.password],
      loginLink: [cred.loginLink],
      forgotEmail: [cred.forgotEmail],
      mobileOTP: [cred.mobileOTP],
      securityQA: [cred.securityQA],
      accessLevel: [cred.accessLevel]
    }));
  });
  this.ehrForm.setControl('loginCredentials', credArray);
}

setClearinghouseCredentials(creds: any[]) {
  const credArray = this.fb.array([]);
  creds.forEach(cred => {
    credArray.push(this.fb.group({
      username: [cred.username],
      password: [cred.password],
      forgotEmail: [cred.forgotEmail],
      mobileOTP: [cred.mobileOTP],
      securityQA: [cred.securityQA],
      accessLevel: [cred.accessLevel]
    }));
  });
  this.clearinghouseForm.setControl('credentials', credArray);
}
setClearinghouseNames(names: any[]) {
  const namesArray = this.fb.array([]);
  names.forEach(n => {
    namesArray.push(this.fb.group({ name: [n.name] }));
  });
  this.clearinghouseForm.setControl('clearinghouseNames', namesArray);
}

setProviders(providers: any[]) {
  const providerArray = this.fb.array([]);
  providers.forEach(provider => {
    providerArray.push(this.fb.group({
      firstName: [provider.firstName],
      lastName: [provider.lastName],
      title: [provider.title],
      credential: [provider.credential],
      npi: [provider.npi],
      documents: this.fb.group(provider.documents || {}) // patch entire documents object
    }));
  });
  this.providerForm.setControl('providers', providerArray);
}

setProviderFiles(providers: any[]) {
  this.uploadedFiles = {}; // clear existing entries first

  providers.forEach((provider, providerIndex) => {
    const documents = provider.documents || {};

    for (const docType of Object.keys(documents)) {
      const key = `${providerIndex}_${docType}`;
      this.uploadedFiles[key] = documents[docType].map((doc: any) => ({
        id:doc.id,
        name: doc.name,
        size: doc.size,
        mimeType: doc.mimeType,
        folderPath: doc.folderPath,
        googleDriveId: doc.googleDriveId,
        googleDriveLink: doc.googleDriveLink
      }));
    }
  });
}


setPracticeLocations(locations: any[]) {
  const locArray = this.fb.array([]);
  locations.forEach(loc => {
    locArray.push(this.fb.group({
      tin: [loc.tin],
      address: [loc.address],
      city: [loc.city],
      state: [loc.state],
      zip: [loc.zip],
      groupNpi: [loc.groupNpi],
      practiceContacts: this.fb.array(loc.practiceContacts.map(pc => this.fb.group({
        email: [pc.email],
        phone: [pc.phone],
        fax: [pc.fax],
        website: [pc.website]
      }))),
      employeeContacts: this.fb.array(loc.employeeContacts.map(ec => this.fb.group({
        name: [ec.name],
        email: [ec.email],
        phone: [ec.phone],
        mobile: [ec.mobile],
        designation: [ec.designation]
      })))
    }));
  });
  this.practiceForm.setControl('locations', locArray);
}







  initializeForm(): void {
    this.form = this.fb.group({
      // Your main form controls...
      employeeContacts: this.fb.array([this.createEmployeeContact()])
    });
  }

   initPayorForm(): void {
    this.payorForm = this.fb.group({
      payorLogins: this.fb.array([this.createPayorLogin()]),
      otherPayorInfo: ['']
    });
  }

  createLocationGroup(): FormGroup {

  return this.fb.group({
    address: ['',Validators.required],
    city: ['',Validators.required],
    state: ['',Validators.required],
    // zip: ['',Validators.required],
    tin: ['',Validators.required],
    groupNpi: ['',Validators.required],
    practiceContacts: this.fb.array([this.createPracticeContact()]),
    employeeContacts: this.fb.array([this.createEmployeeContact()]) // This is where employee contacts belong
  });
}

  createPracticeContact(): FormGroup {
    return this.fb.group({
      phone: [''],
      fax: [''],
      email: [''],
      website: ['']
    });
  }

   createEmployeeContact(): FormGroup {
    return this.fb.group({
      name: [''],
      designation: [''],
      phone: [''],
      mobile: [''],
      email: ['']
    });
  }

  createSupportContact(): FormGroup {
    return this.fb.group({
      contactName: [''],
      email: [''],
      phone: [''],
      website: ['']
    });
  }

  createLoginCredential(): FormGroup {
    return this.fb.group({
      loginLink: [''],
      username: [''],
      password: [''],
      securityQA: [''],
      forgotEmail: [''],
      mobileOTP: [''],
      accessLevel: ['']
    });
  }

  createClearinghouseCredential(): FormGroup {
    return this.fb.group({
      username: [''],
      password: [''],
      securityQA: [''],
      mobileOTP: [''],
      forgotEmail: [''],
      accessLevel: ['']
    });
  }

  createPayor(): FormGroup {
    return this.fb.group({
      payorName: [''],
      website: [''],
      username: [''],
      password: [''],
      securityQA: [''],
      email: [''],
      mobile: ['']
    });
  }
 
 

 createProvider(): FormGroup {
    return this.fb.group({
      title: ['Dr.', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      credential: ['MD', Validators.required],
      npi: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      // ... other fields ...
      documents: this.fb.group({
        dea: [ [] ],
        nyLicense: [ [] ],
        driversLicense: [ [] ],
        clia: [ [] ],
        board: [ [] ]
      })
    });
  }
  get providers(): FormArray {
  return this.providerForm?.get('providers') as FormArray;
}

  //  getProviderFiles(providerIndex: number, controlName: string): FormArray {
  //   return this.providers.at(providerIndex).get(controlName) as FormArray;
  // }

  addProvider(): void {
    this.providers.push(this.createProvider());
  }

  // FormArray getters
  get locations() { return this.practiceForm.get('locations') as FormArray; }
  get supportContacts() { return this.ehrForm.get('supportContacts') as FormArray; }
  get loginCredentials() { return this.ehrForm.get('loginCredentials') as FormArray; }
  get clearinghouseCredentials() { return this.clearinghouseForm.get('credentials') as FormArray; }
  get payors() { return this.payorForm.get('payors') as FormArray; }
  // get providers() { return this.payorForm.get('providers') as FormArray; }
  //  get providers(): FormArray {
  //   return this.providerForm.get('providers') as FormArray;
  // }
 getProviderFiles(providerIndex: number, controlName: string): FormArray {
    return this.providers.at(providerIndex).get(controlName) as FormArray;
  }
  // Add/remove methods
  addLocation() { this.locations.push(this.createLocationGroup()); }
  addSupportContact() { this.supportContacts.push(this.createSupportContact()); }
  addLoginCredential() { this.loginCredentials.push(this.createLoginCredential()); }
  addClearinghouseCredential() { this.clearinghouseCredentials.push(this.createClearinghouseCredential()); }
  addPayor() { this.payors.push(this.createPayor()); }
  // addProvider() { this.providers.push(this.createProvider()); }

  // Fixed remove methods
  removePracticeContact(locationIndex: number, contactIndex: number) {
    const contacts = this.locations.at(locationIndex).get('practiceContacts') as FormArray;
    if (contacts.length > 1) contacts.removeAt(contactIndex);
  }

 removeEmployeeContact(locationIndex: number, contactIndex: number): void {
  const contacts = this.getEmployeeContacts(locationIndex);
  if (contacts.length > 1) {
    contacts.removeAt(contactIndex);
  }
}

  removeSupportContact(index: number) {
    if (this.supportContacts.length > 1) this.supportContacts.removeAt(index);
  }

  removeLoginCredential(index: number) {
    if (this.loginCredentials.length > 1) this.loginCredentials.removeAt(index);
  }

    get providerFormProviders(): FormArray {
    return this.providerForm.get('providers') as FormArray;
  }

  // Step navigation
  goToStep(step: number) {
    this.currentStep = step;
    console.log(step,'step: number')
  }
  logValidationErrors(group: FormGroup | FormArray, parentKey: string = '') {
  Object.keys(group.controls).forEach(key => {
    const control = group.get(key);
    const fullPath = parentKey ? `${parentKey}.${key}` : key;

    if (control instanceof FormGroup || control instanceof FormArray) {
      this.logValidationErrors(control, fullPath);
    } else if (control && control.invalid) {
      console.warn(`Invalid field: ${fullPath}`, control.errors);
    }
  });
}

  nextStep() {
    switch (this.currentStep) {
      case 1:
        console.log(this.practiceForm.valid, 'practiceForm valid')
        this.logValidationErrors(this.practiceForm);

        if (this.practiceForm.valid) {

          this.currentStep++;
          console.log('currentStep')
        } else {
          this.practiceForm.markAllAsTouched();
        }
        break;
      case 2:
        if (this.ehrForm.valid) {
          this.currentStep++;
        } else {
          this.ehrForm.markAllAsTouched();
        }
        break;
      case 3:
        if (this.clearinghouseForm.valid) {
          this.currentStep++;
        } else {
          this.clearinghouseForm.markAllAsTouched();
        }
        break;
      default:
        this.currentStep++;
    }
  }

  prevStep() {
    if (this.currentStep > 1) this.currentStep--;
  }
  getPracticeContacts(index: number): FormArray {
    return this.locations.at(index).get('practiceContacts') as FormArray;
  }
  // Helper to get employee contacts
   getEmployeeContacts(locationIndex: number): FormArray {
  return this.locations.at(locationIndex).get('employeeContacts') as FormArray;
}



  // submitAll() {
  //   const formData = {
  //     practice: this.practiceForm.value,
  //     ehr: this.ehrForm.value,
  //     clearinghouse: this.clearinghouseForm.value,
  //     payor: this.payorForm.value
  //   };
  //   console.log('Complete form data:', formData);
  //   // Submit logic here
  // }
//    onSubmit(): void {
//     if (this.clearinghouseForm.valid) {
//       console.log('Form submitted:', this.clearinghouseForm.value);
//       // Navigate to next step
//     } else {
//       this.markFormGroupTouched(this.clearinghouseForm);
//     }
//     if (this.providerForm.valid) {
//       console.log('Form submitted', this.providerForm.value);
//       // Handle form submission
//     } else {
//       this.providerForm.markAllAsTouched();
//     }


// const formElement = this.formContainer.nativeElement;
//   const inputs = formElement.querySelectorAll('[data-json-path]');
//   const practiceInfo: any = {};  // Dynamic wrapper
//   const formData = new FormData();

//   inputs.forEach((element: any) => {
//     const root = element.closest('[data-json-root]')?.getAttribute('data-json-root');
//     const path = element.getAttribute('data-json-path');
//     if (!path || !root) return;

//     // Dynamically build path inside practiceInfo
//     const fullPath = `${root}.${path}`;

//     if (element.type === 'file') {
//       const providerIndex = element.getAttribute('data-provider-index');
//       const docType = element.getAttribute('data-doc-type');
//       const files = element.files;

//       if (files.length > 0 && providerIndex !== null && docType) {
//         const metadataArray = [];

//         for (let i = 0; i < files.length; i++) {
//           const file = files[i];

//           // Attach actual file to FormData
//           formData.append(`files[${providerIndex}][${docType}]`, file);

//           // Metadata for JSON
//           metadataArray.push({
//             filename: file.name,
//             size: file.size,
//             type: file.type
//           });
//         }

//         this.setNestedValue(practiceInfo, fullPath, metadataArray);
//       }
//     } else {
//       const value = element.value;
//       this.setNestedValue(practiceInfo, fullPath, value);
//     }
//   });

//   // 🔗 Now wrap practiceInfo into one top-level object without hardcoding key name
//   const finalResult = { practice_info: practiceInfo };

//   formData.append('practice_info', JSON.stringify(practiceInfo));
//   console.log('Generated JSON:', JSON.stringify(finalResult, null, 2));
//   console.log("Form Data: ", formData);

//   this.http.post('http://127.0.0.1:8000/uploaddfiles', formData).subscribe({
//     next: (res) => {
//       console.log('Form submitted successfully:', res);
//       alert('Form submitted successfully!');
//     },
//     error: (err) => {
//       console.error('Submission error:', err);
//       alert('Form submission failed.');
//     }
//   });
// }

// onSubmit(): void {
//   if (!this.clearinghouseForm.valid) {
//     this.markFormGroupTouched(this.clearinghouseForm);
//     return;
//   }

//   if (!this.providerForm.valid) {
//     this.providerForm.markAllAsTouched();
//     return;
//   }

//   const formElement = this.formContainer.nativeElement;
//   const inputs = formElement.querySelectorAll('[data-json-path]');
//   const practiceInfo: any = {};  // Collect dynamic data here
//   const formData = new FormData();

//   inputs.forEach((element: any) => {
//     const root = element.closest('[data-json-root]')?.getAttribute('data-json-root');
//     const path = element.getAttribute('data-json-path');
//     if (!path || !root) return;

//     const fullPath = `${root}.${path}`;

//     if (element.type === 'file') {
//       const providerIndex = element.getAttribute('data-provider-index');
//       const docType = element.getAttribute('data-doc-type');
//       const files = element.files;

//       if (files.length > 0 && providerIndex !== null && docType) {
//         const metadataArray = [];

//         for (let i = 0; i < files.length; i++) {
//           const file = files[i];
//           formData.append(`files[${providerIndex}][${docType}]`, file);

//           metadataArray.push({
//             filename: file.name,
//             size: file.size,
//             type: file.type
//           });
//         }

//         this.setNestedValue(practiceInfo, fullPath, metadataArray);
//       }
//     } else {
//       const value = element.value;
//       this.setNestedValue(practiceInfo, fullPath, value);
//     }
//   });

//   // ✅ Merge static form values
//   practiceInfo.clearinghouse = this.clearinghouseForm.value;
//   practiceInfo.providers = this.providerForm.value.providers;

//   const finalPayload = {
//     practice_info: practiceInfo
//   };

//   // ✅ Append final JSON payload as Blob
//   formData.append(
//     'practice_info',
//     new Blob([JSON.stringify(finalPayload)], { type: 'application/json' })
//   );

//   // ✅ Debugging
//   console.log('🔧 Final JSON payload:', JSON.stringify(finalPayload, null, 2));

//   this.http.post('http://127.0.0.1:8000/uploaddfiles', formData).subscribe({
//     next: (res) => {
//       console.log('✅ Form submitted successfully:', res);
//       alert('Form submitted successfully!');
//     },
//     error: (err) => {
//       console.error('❌ Submission error:', err);
//       alert('Form submission failed.');
//     }
//   });
// }



// onSubmit(): void {
//   // Create structured form data object (without validation)
//   const formData = {
//     practice_info: this.practiceForm.value,
//     ehr_system: this.ehrForm.value,
//     clearing_house: this.clearinghouseForm.value,
//     payor_and_providers: {
//       ...this.payorForm.value,
//       providers: this.providerForm.value.providers
//     }
//   };

//   // Create FormData for the upload
//   const uploadData = new FormData();
//    const jsonBlob = new Blob([JSON.stringify(formData)], {
//     type: 'application/json'
//   });
//   uploadData.append('formData', jsonBlob, 'data.json');
  
//   // Add JSON data
//   // uploadData.append('formData', JSON.stringify(formData));
  

//   // Add uploaded files
//   Object.entries(this.uploadedFiles).forEach(([type, files]) => {
//     files.forEach((file, index) => {
//       uploadData.append(`files[${type}][${index}]`, file, file.name);
//     });
//   });

//   console.log('Submitting form data:', formData);
//   console.log('Upload data:', uploadData);

//   // Submit to server
//   this.http.post('http://127.0.0.1:8000/uploaddfiles', uploadData).subscribe({
//     next: (res) => {
//       console.log('Form submitted successfully:', res);
//       alert('Form submitted successfully!');
//     },
//     error: (err) => {
//       console.error('Submission error:', err);
//       alert('Form submission failed.');
//     }
//   });
// }


// onSubmit(): void {
//   // Combine values from all form groups
//   const formData = {
//     practice_info: this.practiceForm.value,
//     ehr_system: this.ehrForm.value,
//     clearing_house: this.clearinghouseForm.value,
//     payor_and_providers: {
//       ...this.payorForm.value,
//       providers: this.providerForm.value.providers
//     }
//   };

//   // Log structured JSON
//   console.log('🧾 Submitting structured JSON:\n', JSON.stringify(formData, null, 2));

//   // Create FormData object to send as multipart/form-data
//   const uploadData = new FormData();

//   // Append JSON as Blob
//   const jsonBlob = new Blob([JSON.stringify(formData)], {
//     type: 'application/json'
//   });
//   uploadData.append('formData', jsonBlob, 'data.json');

//   // Append uploaded files
//   Object.entries(this.uploadedFiles).forEach(([type, files]) => {
//     files.forEach((file, index) => {
//       uploadData.append(`files[${type}][${index}]`, file, file.name);
//     });
//   });

//   console.log('📦 FormData ready to submit:', uploadData);

//   // Submit to backend
//   // this.http.post('http://127.0.0.1:8000/uploadfiles', uploadData).subscribe({
//   //   next: (res) => {
//   //     console.log('✅ Form submitted successfully:', res);
//   //     alert('Form submitted successfully!');
//   //   },
//   //   error: (err) => {
//   //     console.error('❌ Submission error:', err);
//   //     alert('Form submission failed.');
//   //   }
//   // });

// this._AuthService.uploadFile(uploadData).subscribe(
//   (response) => {
//     console.log('✅ Email sent to API. Response:', response);
//   },
//   (error) => {
//     console.error('❌ Error sending email:', error);
//   }
// );
// }

// onSubmit(): void {

//     const clientDataString = localStorage.getItem('temp_numberclient');
//   console.log(this.providerForm.value.providers)
//   const fullForm = {
//     user_id:clientDataString,
//     practice_info: this.practiceForm.value,
//     ehr_system: this.ehrForm.value,
//     clearing_house: this.clearinghouseForm.value,
//     payor_and_providers: {
//       ...this.payorForm.value,
//       providers: this.providerForm.value.providers

      
//     }
//   };

//   console.log('full form: ',fullForm)

//   const uploadData = new FormData();
//   const jsonBlob = new Blob([JSON.stringify(fullForm)], {
//     type: 'application/json'
//   });

//   // uploadData.append('formData', jsonBlob, 'data.json'); // ✅ Must be 'formData'
//   uploadData.append('formData', new Blob([JSON.stringify(fullForm)], { type: 'application/json' }), 'data.json');

//   // console.log("Upload Data from frontend: ", JSON.stringify(uploadData, null, 2));

  

//   Object.entries(this.uploadedFiles).forEach(([key, files]: any) => {
//     files.forEach((file: File, index: number) => {
//       console.log("Files in oject.entries: ",file)
//       console.log("Files in oject.key: ",key)
//       console.log("Files in uploadedFiles.entries: ",this.uploadedFiles)

//       uploadData.append(`files[${key}][${index}]`, file);
//     });
//   });

//   for (const pair of (uploadData as any).entries()) {
//     console.log(pair[0], pair[1]);
//   }


//   this._AuthService.uploadFile(uploadData).subscribe(
//     (res) => console.log('✅ Success:', res),
//     (err) => console.error('❌ Error:', err)
//   );
// }

onSubmit(): void {
  const clientDataString = localStorage.getItem('temp_numberclient');
  this.isSubmitting = true;


  if (!this.providers || !this.providers.length) {
    console.warn('No providers found in form!');
    // return;
  }

  this.providers.controls.forEach((providerGroup, providerIndex) => {
    const documentsGroup = providerGroup.get('documents') as FormGroup;

    Object.keys(documentsGroup.controls).forEach((docType) => {
      const key = `${providerIndex}_${docType}`;
      const files = this.uploadedFiles[key] || [];
      documentsGroup.get(docType)?.setValue(files.length ? files : null);
    });
  });


  const fullForm = {
    user_id: clientDataString,
    practice_info: this.practiceForm.value,
    ehr_system: this.ehrForm.value,
    clearing_house: this.clearinghouseForm.value,
    payor_and_providers: {
      ...this.payorForm.value,
      providers: this.providerForm.value.providers // ✅ reflects updated data
    }
  };

  console.log('full form: ', fullForm);

  const uploadData = new FormData();
  const jsonBlob = new Blob([JSON.stringify(fullForm)], {
    type: 'application/json'
  });

  uploadData.append('formData', jsonBlob, 'data.json');

  Object.entries(this.uploadedFiles).forEach(([key, files]: any) => {
    files.forEach((file: File, index: number) => {
      uploadData.append(`files[${key}][${index}]`, file);
    });
  });
for (const pair of (uploadData as any).entries()) {
  console.log(pair[0], pair[1]);
}

  this._AuthService.uploadFile(uploadData).subscribe(
     (res) => {
      this.isSubmitting = false;
      console.log('✅ Success:', res);
      this._snackBar.open('Form submitted successfully!', 'Close', {
        duration: 5000, // 5 seconds
        panelClass: ['success-snackbar'] // optional - you can style this
      });
    },
    (err) => {
      this.isSubmitting = false;
      console.error('❌ Error:', err);
      this._snackBar.open('Error submitting form!', 'Close', {
        duration: 5000,
        panelClass: ['error-snackbar']
      });
    }
  );
}




  setNestedValue(obj: any, path: string, value: any) {
   
    const keys = path.replace(/\[(\d+)\]/g, '.$1').split('.');
    let current = obj;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (i === keys.length - 1) {
        current[key] = value;
      } else {
        if (!current[key]) {
          current[key] = isNaN(Number(keys[i + 1])) ? {} : [];
        }
        current = current[key];
      }
    }
  }

  

  goBack(): void {
    // Navigation logic to previous step
  }

   private markFormGroupTouched(formGroup: FormGroup | FormArray): void {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markFormGroupTouched(control);
      }
    });
  }



   // Payor Login FormArray methods
  get payorLogins(): FormArray {
    return this.payorForm.get('payorLogins') as FormArray;
  }

  createPayorLogin(): FormGroup {
    return this.fb.group({
      payorName: ['', Validators.required],
      websiteLink: ['', [Validators.required, Validators.pattern('https?://.+')]],
      username: ['', Validators.required],
      password: ['', Validators.required],
      securityQA: [''],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern('[0-9]{10}')]]
    });
  }

  addPayorLogin(): void {
    this.payorLogins.push(this.createPayorLogin());
  }

  removePayorLogin(index: number): void {
    this.payorLogins.removeAt(index);
  }

  

  addProviderSection(): void {
    this.providerFormProviders.push(this.createProvider());
  }

  removeProviderSection(index: number): void {
    if (this.providerFormProviders.length > 1) {
      this.providerFormProviders.removeAt(index);
      



    }
  }

 fileTypes = [
    { name: 'dea', label: 'DEA Certificates', icon: 'description' },
    { name: 'nyLicense', label: 'NY License', icon: 'credit_card' },
    { name: 'driversLicense', label: "Driver's License", icon: 'directions_car' },
    { name: 'clia', label: 'CLIA Certificate (if any)', icon: 'medical_services' },
    { name: 'board', label: 'Board Certification', icon: 'workspace_premium' }
  ];

  uploadedFiles: { [key: string]: File[] } = {};
  
// onFileChange(event: any, type: string, providerIndex: number) {
//   const newFiles: File[] = Array.from(event.target.files);
//   const key = `${providerIndex}_${type}`;

//   if (!this.uploadedFiles[key]) {
//     this.uploadedFiles[key] = [];
//   }

//   // Get already uploaded files for comparison
//   const existingFiles = this.uploadedFiles[key];

//   // Filter out duplicates based on file name and size
//   const uniqueNewFiles = newFiles.filter(newFile => {
//     return !existingFiles.some(existingFile =>
//       existingFile.name === newFile.name && existingFile.size === newFile.size
//     );
//   });

//   this.uploadedFiles[key].push(...uniqueNewFiles);

//   console.log(`Uploaded for provider ${providerIndex}, type ${type}:`, this.uploadedFiles[key]);
// }


getUploadedFiles(type: string, providerIndex: number): File[] {
  const key = `${providerIndex}_${type}`;
  console.log("Uploaded files; ",this.uploadedFiles)

  return this.uploadedFiles[key] || [];
  
}

onFileChange(event: any, type: string, providerIndex: number) {
  const newFiles: File[] = Array.from(event.target.files);
  const key = `${providerIndex}_${type}`;
  console.log("Key of Upload file: ",key)

  if (!this.uploadedFiles[key]) {
    this.uploadedFiles[key] = [];
  }

  // Filter out duplicates
  const uniqueNewFiles = newFiles.filter(newFile => 
    !this.uploadedFiles[key].some(existingFile =>
      existingFile.name === newFile.name && existingFile.size === newFile.size
    )
  );

  this.uploadedFiles[key].push(...uniqueNewFiles);
}

// Optional: Add a method to remove files
// removeFile(type: string, providerIndex: number, fileToRemove: File) {
//   const clientDataString = localStorage.getItem('temp_numberclient');
//   // const drive_link = fileToRemove.googleDriveLink;
//   const drive_link = (fileToRemove as any).googleDriveLink;

//   console.log(fileToRemove)
//   const key = `${providerIndex}_${type}`;
//   console.log("Removed File Name:", fileToRemove.name);
  
//   const removedFilePayload = {
//     driveLink: drive_link,
//     user_id: clientDataString,
//     fileName: fileToRemove.name,
   
//   };
//   console.log("Payload to send on removal:", removedFilePayload);

//   // Send to backend
//   this._AuthService.sendRemovedFiles(removedFilePayload).subscribe({
//     next: (res) => console.log('✅ Removed file sent:', res),
//     error: (err) => console.error('❌ Error sending removed file:', err)
//   });

  
//   this.uploadedFiles[key] = this.uploadedFiles[key].filter(
//     file => file.name !== fileToRemove.name || file.size !== fileToRemove.size
//   );

// }

removeFile(type: string, providerIndex: number, fileToRemove: File) {
  const clientDataString = localStorage.getItem('temp_numberclient');
  const drive_link = (fileToRemove as any).googleDriveLink;
  const key = `${providerIndex}_${type}`;

  // 1. Notify backend
  const removedFilePayload = {
    driveLink: drive_link,
    user_id: clientDataString,
    fileName: fileToRemove.name
  };

  this._AuthService.sendRemovedFiles(removedFilePayload).subscribe({
    next: (res) => console.log('✅ Removed file sent:', res),
    error: (err) => console.error('❌ Error sending removed file:', err)
  });

  // 2. Remove from uploadedFiles (used in UI)
  this.uploadedFiles[key] = (this.uploadedFiles[key] || []).filter(
    file => file.name !== fileToRemove.name || file.size !== fileToRemove.size
  );

  // 3. Remove from providerForm -> documents[type]
  const providersArray = this.providerForm.get('providers') as FormArray;
  const providerGroup = providersArray.at(providerIndex) as FormGroup;
  const documentsGroup = providerGroup.get('documents') as FormGroup;

  const docControl = documentsGroup?.get(type);
  const docValue = docControl?.value;

  if (docControl) {
    if (Array.isArray(docValue)) {
      // Normal case ✅
      const updatedDocs = docValue.filter(
        (doc: any) => doc.name !== fileToRemove.name || doc.size !== fileToRemove.size
      );
      docControl.setValue(updatedDocs);
    } else if (typeof docValue === 'object' && docValue !== null) {
      // Defensive: if it became an object instead of array ❗️
      if (docValue.name === fileToRemove.name && docValue.size === fileToRemove.size) {
        docControl.setValue([]); // remove it entirely
      }
    }
  }
}






  logout() {
    this.user.next(null);

    localStorage.removeItem('userDataclient');

    // this.router.navigate(['auth/login']);
    // this.router.navigateByUrl('/auth/login');
    window.location.href = '/auth/login';


  }

}
